export default __webpack_public_path__ + "static/media/food.70f8b98e.png";